import type { SetupStep } from "@/schemas/orgSetup.schema"

const REQUIRED_SETUP_STEPS: readonly SetupStep[] = ["terms", "email", "wallet"]

export const isSetupDone = ({
    completedSteps,
}: {
    completedSteps: readonly SetupStep[]
}): boolean => REQUIRED_SETUP_STEPS.every(step => completedSteps.includes(step))
